export default (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);

export const isRequired = value => (value ? undefined : 'Required');

export const isEmail = value =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? undefined : 'Must be valid email';

export const isPhoneNumber = value =>
  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value) ? undefined : 'Must be valid phone number';
